"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAdapter = void 0;
function createRequest(config) {
    const headers = new Headers(config.headers);
    if (config.auth) {
        const username = config.auth.username || "";
        const password = config.auth.password
            ? encodeURIComponent(config.auth.password)
            : "";
        headers.set("Authorization", `Basic ${Buffer.from(`${username}:${password}`).toString("base64")}`);
    }
    const method = config.method.toUpperCase();
    const options = {
        headers: headers,
        method
    };
    if (method !== "GET" && method !== "HEAD") {
        options.body = config.data;
    }
    if (!!config.withCredentials) {
        options.credentials = config.withCredentials ? "include" : "omit";
    }
    const fullPath = new URL(config.url, config.baseURL);
    const params = new URLSearchParams(config.params);
    const url = `${fullPath}${params}`;
    return new Request(url, options);
}
function getResponse(request, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let stageOne;
        try {
            stageOne = yield fetch(request);
        }
        catch (e) {
            const error = Object.assign(Object.assign({}, new Error("Network Error")), { config,
                request, isAxiosError: true, toJSON: () => error });
            return Promise.reject(error);
        }
        const response = {
            status: stageOne.status,
            statusText: stageOne.statusText,
            headers: Object.assign({}, stageOne.headers),
            config: config,
            request,
            data: undefined // we set it below
        };
        if (stageOne.status >= 200 && stageOne.status !== 204) {
            switch (config.responseType) {
                case "arraybuffer":
                    response.data = yield stageOne.arrayBuffer();
                    break;
                case "blob":
                    response.data = yield stageOne.blob();
                    break;
                case "json":
                    response.data = yield stageOne.json();
                    break;
                case "formData":
                    response.data = yield stageOne.formData();
                    break;
                default:
                    response.data = yield stageOne.text();
                    break;
            }
        }
        return Promise.resolve(response);
    });
}
function fetchAdapter(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const request = createRequest(config);
        const promiseChain = [getResponse(request, config)];
        if (config.timeout && config.timeout > 0) {
            promiseChain.push(new Promise((res, reject) => {
                setTimeout(() => {
                    const message = config.timeoutErrorMessage
                        ? config.timeoutErrorMessage
                        : "timeout of " + config.timeout + "ms exceeded";
                    const error = Object.assign(Object.assign({}, new Error(message)), { config,
                        request, code: "ECONNABORTED", isAxiosError: true, toJSON: () => error });
                    reject(error);
                }, config.timeout);
            }));
        }
        const response = yield Promise.race(promiseChain);
        return new Promise((resolve, reject) => {
            if (response instanceof Error) {
                reject(response);
            }
            else {
                if (!response.status ||
                    !response.config.validateStatus ||
                    response.config.validateStatus(response.status)) {
                    resolve(response);
                }
                else {
                    const error = Object.assign(Object.assign({}, new Error("Request failed with status code " + response.status)), { config,
                        request, code: response.status >= 500 ? "ERR_BAD_RESPONSE" : "ERR_BAD_REQUEST", isAxiosError: true, toJSON: () => error });
                    reject(error);
                }
            }
        });
    });
}
exports.fetchAdapter = fetchAdapter;
//# sourceMappingURL=fetchadapter.js.map